import ENDPOINTS from 'api/endpoints';
import { doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';

export interface AgentCreationConfig {
  company: string;
  companyUrl: string;
  accountId: string;
  model?: string;
  voiceId?: string;
  languageCode?: string;
  welcomeMessage?: string;
}

export interface VoiceConfig {
  id: string;
  name: string;
  accountId: string | null;
  providerVoiceId: string;
  provider: string;
  config: Record<string, unknown>;
  voiceMetadata: {
    speed?: number;
    pitch?: number;
    stability?: number;
    [key: string]: unknown;
  };
  isPolyVoice: boolean;
}

interface CreateAgentResponse {
  agent: {
    id: string;
    name: string;
    accountId: string;
    created_at: string;
    created_by: string;
    active: boolean;
    last_updated: string;
  };
  voiceAgentPrompt: string;
  companyData: {
    name: string;
    url: string;
    description?: string;
    industry?: string;
    [key: string]: unknown;
  };
  promptFileName: string;
  timing: {
    start: string;
    end: string;
    duration: number;
    [key: string]: unknown;
  };
}

export const createAgent = (config: AgentCreationConfig) => {
  return doPost<CreateAgentResponse>(
    generateNextPath(ENDPOINTS.AGENT_CREATION, {
      accountId: config.accountId,
    }),
    LOGGER_TYPE.JUPITER,
    {
      companyName: config.company,
      companyUrl: config.companyUrl,
      model: config.model,
      voiceId: config.voiceId,
      languageCode: config.languageCode || 'en-US',
      welcomeMessage: config.welcomeMessage,
    },
    { version: 'v1', prefix: 'sourcerer' },
  );
};

export const getVoices = (accountId: string) => {
  return doGet<VoiceConfig[]>(
    generateNextPath(ENDPOINTS.VOICES, {
      accountId,
    }),
    LOGGER_TYPE.AGENT_STREAM,
    { version: 'v1', prefix: 'sourcerer' },
  );
};
